// removed by extract-text-webpack-plugin
module.exports = {"SectionTitle":"NoLeader__SectionTitle__1M1Z9","Forward":"NoLeader__Forward__3ml4q","Note":"NoLeader__Note__2WnSH","Link":"NoLeader__Link__3gyod","Result":"NoLeader__Result__23vVd","RankedUsers":"NoLeader__RankedUsers__3sfg6","RankedUser":"NoLeader__RankedUser__vBel0","Winner":"NoLeader__Winner__2n0n5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Stage/NoLeader/NoLeader.css
// module id = 410
// module chunks = 0